import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
Vue.use(Vuetify);

// @ts-ignore
export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#3C4A66',
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#003781',
                success: '#4CAF50',
                warning: '#ff993f'
            }
        }
    },
    icons: {
        iconfont: 'md'
    }
});
